export const PREFIX = 'document'
export const CREATE_DRAFT = `${PREFIX}/create_draft`
export const SET_DRAFT_FIELD = `${PREFIX}/set_draft_field`
export const SET_DOCUMENT = `${PREFIX}/set_document`
export const SET_DOCUMENTS = `${PREFIX}/set_documents`
export const DELETE_DOCUMENT = `${PREFIX}/delete_document`
export const DELETE_DOCUMENTS = `${PREFIX}/delete_documents`

export const PUT_DOCUMENT = `${PREFIX}/db/put_document`
export const REMOVE_DOCUMENT = `${PREFIX}/db/remove_document`
export const GET_ALL_DOCUMENTS = `${PREFIX}/db/get_all_documents`

export function createDraft(document) {
    return {
      type: CREATE_DRAFT,
      payload: { document }
    }
  }
  
  export function setDraftField(type, id, path, value) {
    return {
      type: SET_DRAFT_FIELD,
      payload: { type, id, path, value }
    }
  }
  
  export function setDocument(document) {
    return {
      type: SET_DOCUMENT,
      payload: { document }
    }
  }
  
  export function setDocuments(documents) {
    return {
      type: SET_DOCUMENTS,
      payload: { documents }
    }
  }
  
  export function deleteDocument(document) {
    return {
      type: DELETE_DOCUMENT,
      payload: { document }
    }
  }

  export function putDraft(draft) {
    const document = removeMeta(draft)
    return {
      type: PUT_DOCUMENT,
      payload: { document }
    }
  }
  export function putDocument(document) {
    return {
      type: PUT_DOCUMENT,
      payload: { document }
    }
  }
  
  export function removeDocument(document) {
    return {
      type: REMOVE_DOCUMENT,
      payload: { document }
    }
  }
  
  export function getAllDocuments(types = []) {    
    return {
      type: GET_ALL_DOCUMENTS,
      payload: { types }
    }
  }